var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrap"},[(_vm.$route.name === 'home')?_c('Header'):_vm._e(),(_vm.$route.name !== 'home')?_c('HeaderColumn'):_vm._e(),(_vm.$route.name === 'home')?_c('Main'):_vm._e(),(_vm.$route.name !== 'home')?_c('MainColumn'):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }